export function buildPaymentPlan(totalMinor, count, firstDate, intervalMonths = 1, upfrontMinor = 0) {
  if (!Number.isSafeInteger(totalMinor) || totalMinor <= 0 || !Number.isInteger(count) || count < 1 || count > 120 || !Number.isInteger(intervalMonths) || intervalMonths < 1 || intervalMonths > 12 || !Number.isSafeInteger(upfrontMinor) || upfrontMinor < 0 || upfrontMinor >= totalMinor) throw new Error("Taksit sayısı, ödeme aralığı veya peşinat geçersiz.");
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(firstDate);
  if (!match) throw new Error("İlk taksit tarihini seçin.");
  const [, year, month, day] = match.map(Number);
  const start = new Date(Date.UTC(year, month - 1, day));
  if (start.getUTCMonth() !== month - 1 || start.getUTCDate() !== day) throw new Error("Geçerli bir tarih seçin.");
  const balance = totalMinor - upfrontMinor;
  if (balance < count) throw new Error("Taksit tutarı en az 0,01 olmalı.");
  const rows = upfrontMinor ? [{ due_date: firstDate, amount: (upfrontMinor / 100).toFixed(2), label: "Peşinat" }] : [];
  for (let i = 0; i < count; i++) {
    const date = new Date(Date.UTC(year, month - 1 + i * intervalMonths, 1));
    const lastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
    date.setUTCDate(Math.min(day, lastDay));
    rows.push({ due_date: date.toISOString().slice(0, 10), label: `${i + 1}. taksit`, amount: ((Math.floor(balance / count) + (i < balance % count ? 1 : 0)) / 100).toFixed(2) });
  }
  return rows;
}
